import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
// import { GetPartNumberDetails } from '../../types/device';
import { PromiseType } from '../../types';

export type DeviceData = PromiseType<ReturnType<typeof DeviceManager.getSiteSubscriptionDetails>>;
type ContextState = Data<DeviceData> | null;
const Context = React.createContext<ContextState | null>(null);

function useGetSiteSubscriptionDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        // throw new Error('useGetPartNumberDetails must be used within a GetPartNumberProvider');
        return null;
    }
    return contextState;
}

const GetSiteSubscriptionProvider: React.FC<{ siteId: string; org?: any }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'get-site-subscription-details',
        id: props.siteId,
        dataFn: React.useCallback(() => DeviceManager.getSiteSubscriptionDetails(authHelper, props.siteId), [
            authHelper,
            props.siteId,
        ]),
    });

    const getSiteSubscriptionData = dataFromDataset(dataset);

    return <Context.Provider value={getSiteSubscriptionData}>{props.children}</Context.Provider>;
};

const TestSiteSubscriptionProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { GetSiteSubscriptionProvider, TestSiteSubscriptionProvider, useGetSiteSubscriptionDetails };
